/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import DateTime from 'react-datetime';
import { formatDateHyphen } from '../../utils/dateHelpers';

class DateRange extends React.Component {
  getClassName = (value) => {
    const { isValid } = this.props;
    return `col-sm-5 ${!isValid && !value ? 'date-container' : ''}`;
  };

  getPlaceHolderText = (value) => {
    const { isValid } = this.props;
    return `${!isValid || !value || value.length === 0 ? 'Required' : ''}`;
  };

  handleDateChange = (newDate, type) => {
    const payload = {};
    payload[type] = formatDateHyphen(newDate);
    if (payload[type]) {
      this.props.onDateChange(payload);
    } else {
      const { startDate, endDate } = this.props;
      payload[type] = formatDateHyphen(
        type === 'end_date' ? endDate : startDate
      );
      this.props.onDateChange(payload);
    }
  };

  render() {
    const { startDate, endDate, validStart, validEnd } = this.props;
    return (
      <div className="date-range">
        <DateTime
          value={startDate}
          dateFormat="MM/DD/YY"
          timeFormat={false}
          onChange={(date) => this.handleDateChange(date, 'start_date')}
          isValidDate={validStart}
          className={this.getClassName(startDate)}
          closeOnSelect
          inputProps={{
            placeholder: this.getPlaceHolderText(startDate),
            readOnly: true
          }}
        />
        <div className="col-sm-1 center">-</div>
        <DateTime
          value={endDate}
          dateFormat="MM/DD/YY"
          timeFormat={false}
          onChange={(date) => this.handleDateChange(date, 'end_date')}
          isValidDate={validEnd}
          className={this.getClassName(endDate)}
          closeOnSelect
          inputProps={{
            placeholder: this.getPlaceHolderText(endDate),
            readOnly: true,
            className: 'end-date form-control'
          }}
        />
      </div>
    );
  }
}

DateRange.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  validStart: PropTypes.func,
  validEnd: PropTypes.func,
  onDateChange: PropTypes.func.isRequired
};

export default DateRange;
